import React, { useState } from 'react';
import {
	useAllItemsQuery,
	useEditItemByIdMutation,
	useCreateItemMutation,
	useDeleteItemByIdMutation
} from '../../../../store/api/item.api';
import styles from '../ItemsAdminPage.module.css';
import { useNavigate } from 'react-router-dom';
import { SharingItemModal } from '../../Modal/SharingItemModal/SharingItemModal';

export const SharingItemsAdminPage = () => {
	const { data: items = [], isLoading, refetch } = useAllItemsQuery({ schema: 'PS_sharing' });
	const [activeMenu, setActiveMenu] = useState(null);
	const [editItemId, setEditItemId] = useState(null);
	const [createMode, setCreateMode] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const navigate = useNavigate();

	const ITEMS_PER_PAGE = 10;

	const [editItem] = useEditItemByIdMutation();
	const [createItem] = useCreateItemMutation();
	const [deleteItem] = useDeleteItemByIdMutation();

	const handleMenuToggle = (itemId) => {
		setActiveMenu((prev) => (prev === itemId ? null : itemId));
	};

	const handleEdit = (itemId) => {
		setEditItemId(itemId);
		setActiveMenu(null);
	};

	const handleCloseModal = () => {
		setEditItemId(null);
		setCreateMode(false);
	};

	const handleItemSubmit = async (formData, itemId = null) => {
		try {
			if (itemId) {
				await editItem({ itemId, data: formData, schema: 'PS_sharing' }).unwrap();
			} else {
				await createItem({ data: formData, schema: 'PS_sharing' }).unwrap();
			}
			refetch();
			handleCloseModal();
		} catch {
			alert('Ошибка при сохранении товара');
		}
	};

	const handleDelete = async (itemId) => {
		if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
			try {
				await deleteItem({ itemId, schema: 'PS_sharing' }).unwrap();
				refetch();
			} catch {
				alert('Ошибка при удалении товара');
			}
		}
	};

	const filteredItems = items.filter((item) =>
		item.title.toLowerCase().includes(searchQuery.toLowerCase())
	);

	const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
	const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
	const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const totalPages = Math.ceil(filteredItems.length / ITEMS_PER_PAGE);

	const paginatePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
	const paginateNext = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

	if (isLoading) return <div className={styles.loading}>Загрузка...</div>;

	return (
		<div className={styles.main}>
			<div className={styles.topBar}>
				<button onClick={() => navigate('/admin')} className={styles.backButton}>← Назад</button>
			</div>

			<h2 className={styles.title}>Sharing Товары</h2>

			<div className={styles.buttonWrapper}>
				<button className={styles.addButton} onClick={() => setCreateMode(true)}>
					Добавить игру
				</button>
			</div>

			<div className={styles.searchWrapper}>
				<input
					type="text"
					placeholder="Поиск по названию..."
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
					className={styles.searchInput}
				/>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Название</div>
				<div>П2 цена</div>
				<div>Категория</div>
				<div>Язык</div>
				<div>inMainSlider</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{currentItems.map((item) => (
					<div key={item.id} className={styles.row}>
						<div>{item.id}</div>
						<div>{item.title}</div>
						<div>{item.P2_price} ₽</div>
						<div>{item.categories[0]?.title || '-'}</div>
						<div>{item.lang || '-'}</div>
						<div>{item.inMainSlider ? 'Да' : 'Нет'}</div>
						<div className={styles.actions}>
							<div onClick={() => handleMenuToggle(item.id)} className={styles.menuIcon}>⋮</div>
							{activeMenu === item.id && (
								<div className={styles.menu}>
									<div onClick={() => handleEdit(item.id)}>Изменить</div>
									<div onClick={() => handleDelete(item.id)}>Удалить</div>
								</div>
							)}
						</div>
					</div>
				))}
			</div>

			<div className={styles.pagination}>
				<button onClick={paginatePrev} disabled={currentPage === 1} className={styles.pageButton}>
					Назад
				</button>
				<span className={styles.pageInfo}>
					Страница {currentPage} из {totalPages}
				</span>
				<button onClick={paginateNext} disabled={currentPage === totalPages} className={styles.pageButton}>
					Вперёд
				</button>
			</div>

			{(editItemId || createMode) && (
				<SharingItemModal
					isOpen={editItemId !== null || createMode}
					onClose={handleCloseModal}
					onSubmit={(formData) => handleItemSubmit(formData, editItemId)}
					item={createMode ? null : items.find((i) => i.id === editItemId)}
				/>
			)}
		</div>
	);
};
